module.exports = __webpack_public_path__ + "static/img/550px.6671cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrier/550px.png
// module id = bbx9
// module chunks = 134